import React from "react";

const Impressum = () => {
    return (
        <div className="informationContainer2">
            <div className="impressum imressum1">
                
                <p>mobile-bühne.at GmbH</p>
                <p>Rheinboldtstraße 12</p>
                <p>2362 Biedermannsdorf</p>
            </div>
            <div className="impressum imressum2">
                
                <p>FN 513691d HG Wr. Neustadt</p>
                <p>UID ATU 74608347</p>
                {/* <p>IBAN AT85 2011 1840 8625 0700</p> */}
            </div>
        </div>
    );
};

export default Impressum;
